module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_AudioOff_16"],"path":[{"$":{"d":"M2.31,5,9,11.69V15L3,11H0V5ZM9,.94,5.81,3.06,9,6.25Zm4.72,10,1.08,1.08a7.72,7.72,0,0,0-1.25-9.77l-1,1.09A6.26,6.26,0,0,1,13.72,11Zm-2.4-2.4L12.55,9.8a5.65,5.65,0,0,0-1.31-5.88L10.17,5a4.23,4.23,0,0,1,1.21,3A4.27,4.27,0,0,1,11.32,8.57ZM.77,0,.06.71,14.25,14.89l.71-.71Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_AudioOff_16.svg
// module id = 13rC
// module chunks = 1